import React from 'react';

const Button = ({ buttonText, ...props }) => (
  <button {...props}><span>{buttonText}</span></button>
);

export default Button;
